import { Group } from '@app/shared/models/group';
import { Role } from '@app/shared/models/role';
import { User } from '@app/shared/models/user';
import { createAction, props } from '@ngrx/store';

// Groups
export const LoadGroups = createAction(
  '[Groups] Load Groups'
);

export const LoadGroupsSuccess = createAction(
  '[Groups] Load Groups Success',
  props<{ groups: Group[] }>()
);

export const LoadGroupsFailure = createAction(
  '[Groups] Load Groups Failure',
  props<{ error: any }>()
);

// Group Details
export const LoadGroupDetails = createAction(
  '[Groups] Load Group Details',
  props<{ id: string }>()
);

export const LoadGroupDetailsSuccess = createAction(
  '[Groups] Load Group Details Success',
  props<{ group: Group }>()
);

export const LoadGroupDetailsFailure = createAction(
  '[Groups] Load Group Details Failure',
  props<{ error: any }>()
);

// Group Roles
export const LoadGroupRoles = createAction(
  '[Groups] Load Group Roles',
  props<{ id: string }>()
);

export const LoadGroupRolesSuccess = createAction(
  '[Groups] Load Group Roles Success',
  props<{ roles: Role[] }>()
);

export const LoadGroupRolesFailure = createAction(
  '[Groups] Load Group Roles Failure',
  props<{ error: any }>()
);

// Group Members
export const LoadGroupMembers = createAction(
  '[Groups] Load Group Members',
  props<{ id: string }>()
);

export const LoadGroupMembersSuccess = createAction(
  '[Groups] Load Group Members Success',
  props<{ members: User[] }>()
);

export const LoadGroupMembersFailure = createAction(
  '[Groups] Load Group Members Failure',
  props<{ error: any }>()
);

// Create group
export const CreateGroup = createAction(
  '[Groups] Create Group',
  props<{ name: string }>()
);

export const CreateGroupSuccess = createAction(
  '[Groups] Create Group Success',
  props<{ group: Group }>()
);

export const CreateGroupFailure = createAction(
  '[Groups] Create Group Failure',
  props<{ error: any }>()
);

// Attach Member to group
export const AttachMemberToGroup = createAction(
  '[Groups] Attach Member To Group',
  props<{ userId: string, groupId: string }>()
);

export const AttachMemberToGroupSuccess = createAction(
  '[Groups] Attach Member To Group Success'
);

export const AttachMemberToGroupFailure = createAction(
  '[Groups] Attach Member To Group Failure',
  props<{ error: any }>()
);

// Attach Role to group
export const AttachRoleToGroup = createAction(
  '[Groups] Attach Role To Group',
  props<{ groupId: string, role: any }>()
);

export const AttachRoleToGroupSuccess = createAction(
  '[Groups] Attach Role To Group Success'
);

export const AttachRoleToGroupFailure = createAction(
  '[Groups] Attach Role To Group Failure',
  props<{ error: any }>()
);

// Detach Role from group
export const DetachRoleFromGroup = createAction(
  '[Groups] Detach Role From Group',
  props<{ groupId: string, role: any }>()
);

export const DetachRoleFromGroupSuccess = createAction(
  '[Groups] Detach Role From Group Success'
);

export const DetachRoleFromGroupFailure = createAction(
  '[Groups] Detach Role From Group Failure',
  props<{ error: any }>()
);

// Detach Member from group
export const DetachMemberFromGroup = createAction(
  '[Groups] Detach Member From Group',
  props<{ userId: string, groupId: string }>()
);

export const DetachMemberFromGroupSuccess = createAction(
  '[Groups] Detach Member From Group Success'
);

export const DetachMemberFromGroupFailure = createAction(
  '[Groups] Detach Member From Group Failure',
  props<{ error: any }>()
);

// Update group
export const UpdateGroup = createAction(
  '[Groups] Update Group',
  props<{ group: any }>()
);

export const UpdateGroupSuccess = createAction(
  '[Groups] Update Group Success',
  props<{ group: Group }>()
);

export const UpdateGroupFailure = createAction(
  '[Groups] Update Group Failure',
  props<{ error: any }>()
);

// Delete group
export const DeleteGroup = createAction(
  '[Groups] Delete Group',
  props<{ groupId: string }>()
);

export const DeleteGroupSuccess = createAction(
  '[Groups] Delete Group Success'
);

export const DeleteGroupFailure = createAction(
  '[Groups] Delete Group Failure',
  props<{ error: any }>()
);